import {
  Menu, MenuButton, MenuItem, MenuItems
} from '@headlessui/react'
import {
  ChevronDown, UserCircle
} from 'lucide-react'

interface ProfileMenuProps {
  name: string | null | undefined
  picture: string | null | undefined
  onLogout: () => void
  onLogoutEverywhere: () => void
}

const ITEM_CLASSES = 'block w-full text-left px-4 py-2 text-sm text-gray-700 data-[focus]:bg-primary-50 data-[focus]:text-primary-600'

export function ProfileMenu({
  name, picture, onLogout, onLogoutEverywhere,
}: ProfileMenuProps): JSX.Element {
  return (
    <Menu>
      <MenuButton className="flex items-center gap-3 rounded-lg px-1 py-1 text-sm text-gray-700 hover:text-primary-600 focus:outline-none data-[focus]:ring-2 data-[focus]:ring-primary-200">
        {picture ? (
          <img
            src={picture}
            alt="Profile"
            className="w-8 h-8 rounded-full ring-2 ring-primary-100"
          />
        ) : (
          <UserCircle className="w-8 h-8 text-gray-400" />
        )}
        <span>{name}</span>
        <ChevronDown className="w-4 h-4 text-gray-400" aria-hidden="true" />
      </MenuButton>
      <MenuItems
        anchor="bottom end"
        className="z-50 mt-2 w-56 rounded-lg border border-gray-200 bg-white py-1 shadow-soft-lg focus:outline-none"
      >
        <MenuItem>
          <button type="button" onClick={onLogout} className={ITEM_CLASSES}>
            Logout
          </button>
        </MenuItem>
        <MenuItem>
          <button
            type="button"
            onClick={onLogoutEverywhere}
            title="Use after changing or resetting the password you use to sign in to Catch"
            className={ITEM_CLASSES}
          >
            Sign out on all devices
          </button>
        </MenuItem>
      </MenuItems>
    </Menu>
  )
}
